import {throttle} from "lodash-es";

const ProductOrderBadge = (function(window, $) {
    function ProductOrderBadge() {
        this.bookTabButtons = $('.section-book-info .book-tab-buttons');
        this.orderInfoBlock = $('.floating-product-order-badge-container.active .order-info, .product-order-badge.active .order-info');
        this.productBadgeHeader = $('.product-order-badge.active .order-info, .product-order-badge.active .book-cover'); // this is the one attached to the header on desktop devices
        this.floatingOrderBadge = $('.floating-product-order-badge-container .floating-product-order-badge.active .order-info'); // this is the one attached to the footer on mobile devices
        this.bookTitle = $('.floating-product-order-badge-container .book-title');

        this.addEvents();
        this.showProductOrderBadge();
    }

    ProductOrderBadge.prototype.addEvents = function() {
        this.orderInfoBlock.on('click', this.handleClickBookType.bind(this));
        this.bookTabButtons.on('click', this.showProductOrderBadge.bind(this));
    };

    // Create smooth scroll to event and add a little animation as well to highlight the action you just triggered
    // We're scrolling to the the book tab buttons again, since you clicked on the price and/order booktype
    ProductOrderBadge.prototype.handleClickBookType = function() {
        let activeBookTypeContainer = this.bookTabButtons;

        if(this.bookTabButtons.length > 0) {
            $('html, body').stop().animate({
                scrollTop: this.bookTabButtons.offset().top - 232 // We don't know any headers taller then 200px and they probably will not be created as well
            }, 750, function () {
                activeBookTypeContainer.addClass('is-highlighted');
                setTimeout(function () {
                    activeBookTypeContainer.removeClass('is-highlighted');
                }, 500);
            });
        }
    }


    // Show the floating order badge on mobile devices when we scroll by the other primary/main CTA add to cart button within the viewport
    // Be aware there is more functionality in the tabs.js file which hides and shows the floating order badge as well within .tab-content. Below is just product order badges specific
    ProductOrderBadge.prototype.showProductOrderBadge = function() {

        let productOrderBadgeContainer = $('.product-order-badge.active'); // attached to the header - only target the 'active' product order badges
        let floatingOrderBadgeContainer = $('.floating-product-order-badge-container.active'); // footer on mobile devices - only target the 'active' product order badges
        let addToCartBtn = $('.book-type-info.active .order-buttons-container'); // the order button within the book type info section
        let bodyClass = $('body');

        if(floatingOrderBadgeContainer.length > 0 || productOrderBadgeContainer.length > 0) {
            floatingOrderBadgeContainer.addClass('is-hidden');
            productOrderBadgeContainer.addClass('is-hidden');

            const calcScrollPos = () => {
                let scrollPos = document.documentElement.scrollTop || window.scrollY; // scrollY needed for Safari

                if(scrollPos >= addToCartBtn.offset().top - 200) { // there are most probably no headers taller then 200px and they probably will not be created as well
                    floatingOrderBadgeContainer.removeClass('is-hidden');
                    productOrderBadgeContainer.removeClass('is-hidden');
                    bodyClass.addClass('floating-product-order-badge-active');
                } else {
                    floatingOrderBadgeContainer.addClass('is-hidden');
                    productOrderBadgeContainer.addClass('is-hidden');
                    bodyClass.removeClass('floating-product-order-badge-active');
                }
            }

            // add a throttle to the scroll event to prevent the scroll event from firing too often
            $(window).on('scroll', throttle(() => {
                calcScrollPos();
            }, 750));
        }
    }


    return ProductOrderBadge;

}(window, jQuery));

export {ProductOrderBadge};
